export default __webpack_public_path__ + "static/media/ic_btc_24.f992927a.svg";